import { render, staticRenderFns } from "./GroundingGoods.vue?vue&type=template&id=e035a344&scoped=true"
import script from "./GroundingGoods.vue?vue&type=script&lang=ts"
export * from "./GroundingGoods.vue?vue&type=script&lang=ts"
import style0 from "./GroundingGoods.vue?vue&type=style&index=0&id=e035a344&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e035a344",
  null
  
)

export default component.exports